import { render, staticRenderFns } from "./PendingApprovalDoctors.vue?vue&type=template&id=5da376bc&"
import script from "./PendingApprovalDoctors.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalDoctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports